import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import AdminRequestForm from './admin-request-form';



export default function AdminRequestDialog(props) {
  return (
      <Dialog open={props.open} onClose={props.close} aria-labelledby="form-dialog-title" scroll='body' maxWidth='xs' fullWidth>
        <DialogTitle id="form-dialog-title">
            { props.edit? <>Edit Request</> : <>Add Request</> }
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            submit for { props.edit? <>The Request Update</> : <>The New Request</> } 
          </DialogContentText>
          <AdminRequestForm request={props.request} submit={props.submit} close={props.close}/>
        </DialogContent>
      </Dialog>
  );
}